import { render, staticRenderFns } from "./changelog_ai.vue?vue&type=template&id=ee7951ca&"
import script from "./changelog_ai.vue?vue&type=script&lang=js&"
export * from "./changelog_ai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports